<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="title"></a><a id="page_iii">BANDIT MENTALITY</a></h1><a id="page_iii">
<p class="subtitle"><span class="bold">HUNTING INSURGENTS IN THE RHODESIAN BUSH WAR, A MEMOIR</span></p>
<p class="author"><span class="bold">Lindsay O’Brien</span></p>
<p class="pub-image"><img alt="Images" src="images/pub.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?6f2b3923